export default {
    '/': ['home'],
    '/load': ['load'],
    '/list': ['list'],
    '/page': ['page'],
    '/view': ['view'],
    '/formdata': ['formdata'],
    '/simpleformdata': ['simpleformdata'],
    '/simpleview': ['simpleview'],
    // '/form': ['form'],
    // '/form/data': ['form', 'formData'],
    // '/form/map': ['form', 'formMap']
}